import { create } from "zustand";

export type ToastKind = "info" | "success" | "error";

export interface Toast {
  id: number;
  message: string;
  kind: ToastKind;
  href?: string;
  durationMs: number;
}

interface ToastState {
  toasts: Toast[];
  push: (message: string, opts?: { kind?: ToastKind; href?: string; durationMs?: number }) => void;
  dismiss: (id: number) => void;
}

let nextId = 1;

export const useToast = create<ToastState>((set) => ({
  toasts: [],
  push: (message, opts) => {
    const id = nextId++;
    const toast: Toast = {
      id,
      message,
      kind: opts?.kind ?? "info",
      href: opts?.href,
      durationMs: opts?.durationMs ?? 5000,
    };
    set((s) => ({ toasts: [...s.toasts, toast] }));
    if (toast.durationMs > 0) {
      setTimeout(() => {
        useToast.getState().dismiss(id);
      }, toast.durationMs);
    }
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));